<template>
    <div class="by-effect">
        <div class="by-effect-wrapper">
            <div class="image">
                <slot name="header"></slot>
            </div>
            <div class="content">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : 'isPatientPlanBaby'
}
</script>

<style lang="scss">
.by-effect{
    display: flex;
    align-items: center;
}

.by-effect-wrapper{
    width: 405px;
    height: auto;
    border-radius: 10px;
    background: #F1F4F5;

    .image{
        width: 100%;
        height: 120px;

        img{
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            width: 100%;
        }
    }

    .content{
        padding: 34px 40px 40px;

        p{
            padding-bottom: 16px;
            text-align: left;

            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            color: #575A5D;
        }

        p:last-child {
             padding-bottom: 0;
        }

        .baby{
            display: flex;
            flex-direction: row;
            align-items: center;

            svg{
                width: 60px;
                height: auto;
                min-width: 60px;
            }
        }
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .by-effect-wrapper{
        width: 40vw;
        height: auto;

        .image{
            width: 100%;
            height: auto;
        }

        .content{
            padding: 2.083vw 2.604vw 2.604vw;

            p{
                padding-bottom: 16px;

                font-size: 1.198vw;
                line-height: 1.563vw;
            }

            p:last-child {
                padding-bottom: 0;
            }
        }
    }
}

@media (max-width: 599px){
    .by-effect{
        align-items: flex-start;
        height: 100%;
    }

    .by-effect-wrapper{
        width: 100%;
        height: auto;

        .image{
            height: auto;
        }

        .content{
            padding: 5.556vw 5.556vw 6.667vw;
            
            .baby{
                display: flex;
                flex-direction: row;

                svg{
                    width: 50px;
                    height: auto;
                    min-width: 50px;
                }
            }

            p{
                padding-bottom: 4.444vw;

                font-size: 4.444vw;
                line-height: 5.556vw;
            }
        }
    }
}
</style>